module.exports = inversify;